// extracted by mini-css-extract-plugin
export default {"spinner-container":"styles_spinner-container__ZxlcS","spinner":"styles_spinner__FS2kw","customerAttachmentsLoading":"styles_customerAttachmentsLoading__iJiXE"};